import Button from "./Button";

export default function ComponentsOverrides(theme) {
  return Object.assign(Button(theme));
}
